import { render, staticRenderFns } from "./myTeamList.vue?vue&type=template&id=66b3a2c6&scoped=true&"
import script from "./myTeamList.vue?vue&type=script&lang=js&"
export * from "./myTeamList.vue?vue&type=script&lang=js&"
import style0 from "./myTeamList.vue?vue&type=style&index=0&id=66b3a2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b3a2c6",
  null
  
)

export default component.exports